(function () {

  /**
   * Simple service for testing if a feature is enabled for a customer.
   */
  angular
    .module('core')
    .factory('edxFeatureFlagService', [
      'authentication',
      'configuration',
      EdxFeatureFlagServiceFactory]);

  function EdxFeatureFlagServiceFactory(
    authentication,
    configuration
  ) {

    function isNweaEnabled(customer) {
      if (!customer) {
        customer = authentication.getCustomer();
      }

      // GA is enabled - all customers get NWEA unless disabled via tag
      return !customer.hasTag('NWEA_DISABLED');
    }

    function isAstRestrictionEnabled(customer) {
      var featureEnabled = configuration.isFeatureEnabledWithDefault('ast_restrictions', true);
      return featureEnabled;
    }

    function isPdOnBoardingEnabled() {
      return configuration.isFeatureEnabledWithDefault('pd_onboarding', false);
    }

    function isClassroomLoginCodesEnabled() {
      return configuration.isFeatureEnabledWithDefault('show_classroom_login_code', false);
    }

    function isChatEnabled() {
      var customer = authentication.getCustomer();
      return customer.chat_enabled;
    }

    return {
      isChatEnabled: isChatEnabled,
      isNweaEnabled: isNweaEnabled,
      isAstRestrictionEnabled: isAstRestrictionEnabled,
      isPdOnBoardingEnabled: isPdOnBoardingEnabled,
      isClassroomLoginCodesEnabled: isClassroomLoginCodesEnabled
    };
  }

})();
